import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle, Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { CrownLogo } from "./CrownLogo";
import { CONTACT_EMAIL, CONTACT_PHONE, WHATSAPP_URL, SOCIALS } from "../lib/constants";

const ICONS = { Instagram, Facebook, Youtube, Music2 };

export const Footer = () => (
  <footer className="border-t border-charcoal-border bg-charcoal" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-6 py-14">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <CrownLogo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
            Premium scalp health analysis built exclusively for people with locs. By Carlocs Group.
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-xs uppercase tracking-[0.25em] text-gold">Contact</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li><a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2 hover:text-cream" data-testid="footer-email"><Mail className="h-4 w-4 text-gold" /> {CONTACT_EMAIL}</a></li>
            <li><a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-cream" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-gold" /> WhatsApp {CONTACT_PHONE}</a></li>
            <li><a href={`tel:${CONTACT_PHONE.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-cream" data-testid="footer-phone"><Phone className="h-4 w-4 text-gold" /> {CONTACT_PHONE}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs uppercase tracking-[0.25em] text-gold">Social</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.icon] || Instagram;
              return (
                <li key={s.name}>
                  <a href={s.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-cream" data-testid={`footer-${s.name.toLowerCase()}`}>
                    <Icon className="h-4 w-4 text-gold" /> {s.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-xs uppercase tracking-[0.25em] text-gold">Company</h4>
          <ul className="space-y-3 text-sm text-muted-foreground">
            <li><Link to="/faq" className="hover:text-cream" data-testid="footer-faq">FAQ</Link></li>
            <li><Link to="/terms" className="hover:text-cream" data-testid="footer-terms">Terms of Use</Link></li>
            <li><Link to="/privacy" className="hover:text-cream" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/reviews" className="hover:text-cream" data-testid="footer-reviews">Reviews</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-charcoal-border pt-6 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Carlocs Group. All rights reserved. Observations only — not a medical diagnosis.
      </div>
    </div>
  </footer>
);
